var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c("b-col", { attrs: { cols: "12" } }, [
            _c(
              "div",
              { staticClass: "d-flex justify-content-end my-1" },
              [
                _vm.HasPermission(_vm.PermissionList.Sales_Create)
                  ? _c(
                      "b-button",
                      {
                        attrs: {
                          variant: "primary",
                          to: "/proforma/add",
                          disabled: _vm.loading,
                        },
                      },
                      [
                        _c("span", { staticClass: "text-nowrap" }, [
                          _vm._v("Add Proforma"),
                        ]),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _c(
            "b-col",
            { staticClass: "my-1", attrs: { cols: "12", md: "2", sm: "2" } },
            [
              _c(
                "b-form-group",
                { staticClass: "mb-0" },
                [
                  _c(
                    "label",
                    { staticClass: "d-inline-block text-sm-left mr-50" },
                    [_vm._v("Per page")]
                  ),
                  _c("b-form-select", {
                    attrs: {
                      id: "perPageSelect",
                      size: "sm",
                      options: _vm.pageOptions,
                    },
                    model: {
                      value: _vm.perPage,
                      callback: function ($$v) {
                        _vm.perPage = $$v
                      },
                      expression: "perPage",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-col",
            {
              staticClass: "d-flex justify-content-end mb-2",
              staticStyle: { position: "relative", "z-index": "1" },
              attrs: { cols: "12" },
            },
            [
              _vm.HasPermission(_vm.PermissionList.Sales_Search)
                ? _c(
                    "b-button",
                    {
                      attrs: {
                        variant: "outline-danger",
                        disabled: !_vm.anyFilterActive,
                      },
                      on: { click: _vm.clearFilters },
                    },
                    [_vm._v(" Clear Filters ")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c("b-table", {
                attrs: {
                  striped: "",
                  hover: "",
                  responsive: "",
                  "per-page": _vm.perPage,
                  "current-page": _vm.currentPage,
                  items: _vm.filteredSalesOrders,
                  fields: _vm.fields,
                  "sort-by": _vm.sortBy,
                  "sort-desc": _vm.sortDesc,
                  "sort-direction": _vm.sortDirection,
                },
                on: {
                  "update:sortBy": function ($event) {
                    _vm.sortBy = $event
                  },
                  "update:sort-by": function ($event) {
                    _vm.sortBy = $event
                  },
                  "update:sortDesc": function ($event) {
                    _vm.sortDesc = $event
                  },
                  "update:sort-desc": function ($event) {
                    _vm.sortDesc = $event
                  },
                  filtered: _vm.onFiltered,
                },
                scopedSlots: _vm._u([
                  {
                    key: "head(orderNumber)",
                    fn: function () {
                      return [
                        _c(
                          "div",
                          { staticClass: "d-flex flex-column" },
                          [
                            _c("span", [_vm._v("PROFORMA NUMBER")]),
                            _vm.HasPermission(_vm.PermissionList.Sales_Search)
                              ? _c("b-form-input", {
                                  attrs: {
                                    placeholder: "Filter by Proforma Number",
                                    size: "sm",
                                  },
                                  on: { input: _vm.filterTable },
                                  model: {
                                    value: _vm.columnFilters.orderNumber,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.columnFilters,
                                        "orderNumber",
                                        $$v
                                      )
                                    },
                                    expression: "columnFilters.orderNumber",
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "head(leadClientName)",
                    fn: function () {
                      return [
                        _c(
                          "div",
                          { staticClass: "d-flex flex-column" },
                          [
                            _c("span", [_vm._v("CUSTOMER")]),
                            _vm.HasPermission(_vm.PermissionList.Sales_Search)
                              ? _c("b-form-input", {
                                  attrs: {
                                    placeholder: "Filter by Customer",
                                    size: "sm",
                                  },
                                  on: { input: _vm.filterTable },
                                  model: {
                                    value: _vm.columnFilters.leadClientName,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.columnFilters,
                                        "leadClientName",
                                        $$v
                                      )
                                    },
                                    expression: "columnFilters.leadClientName",
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "head(salesPersonId)",
                    fn: function () {
                      return [
                        _c(
                          "div",
                          { staticClass: "d-flex flex-column" },
                          [
                            _c("span", [_vm._v("Sales Person")]),
                            _vm.HasPermission(_vm.PermissionList.Sales_Search)
                              ? _c("b-form-input", {
                                  attrs: {
                                    placeholder: "Filter by Sales Person",
                                    size: "sm",
                                  },
                                  on: { input: _vm.filterTable },
                                  model: {
                                    value: _vm.columnFilters.salesPersonId,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.columnFilters,
                                        "salesPersonId",
                                        $$v
                                      )
                                    },
                                    expression: "columnFilters.salesPersonId",
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "cell(jobCardDetails.jobCardNumber)",
                    fn: function (data) {
                      return [
                        data.item.jobCardDetails &&
                        data.item.jobCardDetails.length > 0
                          ? _c(
                              "div",
                              [
                                _c(
                                  "b-button",
                                  {
                                    attrs: { variant: "primary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.openModal(
                                          data.item.jobCardDetails
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(" View ")]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                  {
                    key: "cell(isActive)",
                    fn: function (data) {
                      return [
                        data.item.isActive
                          ? _c("b-badge", { attrs: { variant: "primary" } }, [
                              _vm._v(" Active "),
                            ])
                          : _c("b-badge", { attrs: { variant: "danger" } }, [
                              _vm._v(" Inactive "),
                            ]),
                      ]
                    },
                  },
                  {
                    key: "cell(total)",
                    fn: function (data) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              data.item.currency == null
                                ? "Rs"
                                : _vm.getCurrencySymbol(data.item.currency)
                            ) +
                            " " +
                            _vm._s(data.item.total.toFixed(2)) +
                            " "
                        ),
                      ]
                    },
                  },
                  {
                    key: "cell(salesPersonId)",
                    fn: function (data) {
                      return [
                        data.item.salesPersonId === null
                          ? _c("p", [_vm._v("-")])
                          : _c("p", [
                              _vm._v(
                                _vm._s(
                                  _vm.getSalePersonName(data.item.salesPersonId)
                                )
                              ),
                            ]),
                      ]
                    },
                  },
                  {
                    key: "head(issuedDate)",
                    fn: function () {
                      return [
                        _c(
                          "div",
                          { staticClass: "d-flex flex-column" },
                          [
                            _c("span", [_vm._v("Issue Date")]),
                            _c("date-picker", {
                              staticClass: "small-datepicker",
                              attrs: {
                                range: true,
                                format: "YYYY-MM-DD",
                                placeholder: "Select Date Range",
                                clearable: false,
                                "input-attr": { readonly: true },
                              },
                              on: { change: _vm.filterTable },
                              model: {
                                value: _vm.columnFilters.issuedDateRange,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.columnFilters,
                                    "issuedDateRange",
                                    $$v
                                  )
                                },
                                expression: "columnFilters.issuedDateRange",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "head(orderType)",
                    fn: function () {
                      return [
                        _c(
                          "div",
                          { staticClass: "d-flex flex-column" },
                          [
                            _c("span", [_vm._v("ORDER TYPE")]),
                            _c(
                              "b-form-select",
                              {
                                attrs: { size: "sm" },
                                on: { change: _vm.filterTable },
                                model: {
                                  value: _vm.columnFilters.orderType,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.columnFilters,
                                      "orderType",
                                      $$v
                                    )
                                  },
                                  expression: "columnFilters.orderType",
                                },
                              },
                              [
                                _c("option", { attrs: { value: "" } }, [
                                  _vm._v("All"),
                                ]),
                                _c(
                                  "option",
                                  { attrs: { value: "Variable Order" } },
                                  [_vm._v("Variable Order")]
                                ),
                                _c(
                                  "option",
                                  { attrs: { value: "OneOff Order" } },
                                  [_vm._v("OneOff Order")]
                                ),
                                _c(
                                  "option",
                                  { attrs: { value: "Cancelled" } },
                                  [_vm._v("Cancelled")]
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "head(createdOn)",
                    fn: function () {
                      return [
                        _c(
                          "div",
                          { staticClass: "d-flex flex-column" },
                          [
                            _c("span", [_vm._v("Created On")]),
                            _c("date-picker", {
                              staticClass: "small-datepicker",
                              attrs: {
                                range: true,
                                format: "YYYY-MM-DD",
                                placeholder: "Select Date Range",
                                clearable: false,
                                "input-attr": { readonly: true },
                              },
                              on: { change: _vm.filterTable },
                              model: {
                                value: _vm.columnFilters.createdDateRange,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.columnFilters,
                                    "createdDateRange",
                                    $$v
                                  )
                                },
                                expression: "columnFilters.createdDateRange",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "cell(issuedDate)",
                    fn: function (data) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.convertTimestampToDate(data.item.issuedDate)
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                  {
                    key: "cell(createdOn)",
                    fn: function (data) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.convertTimestampToDate(data.item.createdOn)
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                  {
                    key: "head(status)",
                    fn: function () {
                      return [
                        _c(
                          "div",
                          { staticClass: "d-flex flex-column" },
                          [
                            _c("span", [_vm._v("STATUS")]),
                            _c(
                              "b-form-select",
                              {
                                attrs: { size: "sm" },
                                on: { change: _vm.filterTable },
                                model: {
                                  value: _vm.columnFilters.status,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.columnFilters, "status", $$v)
                                  },
                                  expression: "columnFilters.status",
                                },
                              },
                              [
                                _c("option", { attrs: { value: "" } }, [
                                  _vm._v("All"),
                                ]),
                                _c("option", { attrs: { value: "PROFORMA" } }, [
                                  _vm._v("PROFORMA"),
                                ]),
                                _c("option", { attrs: { value: "ONDEMAND" } }, [
                                  _vm._v("ONDEMAND"),
                                ]),
                                _c("option", { attrs: { value: "READY" } }, [
                                  _vm._v("READY"),
                                ]),
                                _c("option", { attrs: { value: "INVOICED" } }, [
                                  _vm._v("INVOICED"),
                                ]),
                                _c(
                                  "option",
                                  { attrs: { value: "CANCELLED" } },
                                  [_vm._v("CANCELLED")]
                                ),
                                _c("option", { attrs: { value: "Blocked" } }, [
                                  _vm._v("Blocked"),
                                ]),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "cell(orderType)",
                    fn: function (data) {
                      return [
                        data.item.orderType === 1
                          ? _c("b-badge", { attrs: { variant: "primary" } }, [
                              _vm._v("Variable Order"),
                            ])
                          : data.item.orderType === 2
                          ? _c("b-badge", { attrs: { variant: "secondary" } }, [
                              _vm._v("OneOff Order"),
                            ])
                          : data.item.orderType === 3
                          ? _c("b-badge", { attrs: { variant: "warning" } }, [
                              _vm._v("Cancelled"),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                  {
                    key: "cell(status)",
                    fn: function (data) {
                      return [
                        data.item.status === 0
                          ? _c("b-badge", { attrs: { variant: "secondary" } }, [
                              _vm._v("PROFORMA"),
                            ])
                          : data.item.status === 1
                          ? _c("b-badge", { attrs: { variant: "warning" } }, [
                              _vm._v("ONDEMAND"),
                            ])
                          : data.item.status === 2
                          ? _c("b-badge", { attrs: { variant: "info" } }, [
                              _vm._v("READY"),
                            ])
                          : data.item.status === 3
                          ? _c("b-badge", { attrs: { variant: "info" } }, [
                              _vm._v("INVOICED"),
                            ])
                          : data.item.status === 4
                          ? _c("b-badge", { attrs: { variant: "danger" } }, [
                              _vm._v("CANCELLED"),
                            ])
                          : _c("b-badge", { attrs: { variant: "danger" } }, [
                              _vm._v("Blocked"),
                            ]),
                      ]
                    },
                  },
                  {
                    key: "cell(actions)",
                    fn: function (data) {
                      return [
                        _c(
                          "b-dropdown",
                          {
                            attrs: {
                              variant: "link",
                              "toggle-class": "text-decoration-none",
                              "no-caret": "",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "button-content",
                                  fn: function () {
                                    return [
                                      _c("feather-icon", {
                                        staticClass:
                                          "text-body align-middle mr-25",
                                        attrs: {
                                          icon: "MoreVerticalIcon",
                                          size: "16",
                                        },
                                      }),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [
                            _c(
                              "b-dropdown-item",
                              {
                                attrs: {
                                  to: _vm.getSalesOrderIdView(data.item.id),
                                },
                              },
                              [
                                _c("feather-icon", {
                                  staticClass: "mr-50",
                                  attrs: { icon: "EyeIcon" },
                                }),
                                _c("span", [_vm._v("View")]),
                              ],
                              1
                            ),
                            data.item.status === 0
                              ? _c(
                                  "b-dropdown-item",
                                  {
                                    attrs: {
                                      to: _vm.getSalesOrderId(data.item.id),
                                    },
                                  },
                                  [
                                    _c("feather-icon", {
                                      staticClass: "mr-50",
                                      attrs: { icon: "Edit2Icon" },
                                    }),
                                    _c("span", [_vm._v("Edit")]),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            data.item.status === 0 || data.item.status === 1
                              ? _c(
                                  "b-dropdown-item",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.removesalesOrder(data.item)
                                      },
                                    },
                                  },
                                  [
                                    _c("feather-icon", {
                                      staticClass: "mr-50",
                                      attrs: { icon: "TrashIcon" },
                                    }),
                                    _c("span", [_vm._v("Cancel")]),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c(
                "div",
                { staticClass: "d-flex justify-content-center mb-1" },
                [
                  _vm.salesOrderList.length === 0
                    ? _c(
                        "b-alert",
                        {
                          staticClass: "d-flex justify-content-center",
                          attrs: { variant: "warning", show: "" },
                        },
                        [
                          _c("h4", { staticClass: "alert-heading" }, [
                            _vm._v("No Proformas yet"),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "d-flex justify-content-center mb-1" },
                [
                  _vm.loading
                    ? _c("b-spinner", {
                        staticStyle: { width: "3rem", height: "3rem" },
                        attrs: {
                          variant: "success",
                          label: "Spinning",
                          block: "",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c("b-pagination", {
                staticClass: "my-0",
                attrs: {
                  "total-rows": _vm.totalRows,
                  "per-page": _vm.perPage,
                  align: "center",
                  size: "sm",
                },
                model: {
                  value: _vm.currentPage,
                  callback: function ($$v) {
                    _vm.currentPage = $$v
                  },
                  expression: "currentPage",
                },
              }),
              _c("b-form-group", [
                _vm._v(
                  " Showing " +
                    _vm._s(
                      _vm.totalRows > 0
                        ? _vm.perPage * (_vm.currentPage - 1) + 1
                        : 0
                    ) +
                    " to " +
                    _vm._s(
                      _vm.totalRows > 0
                        ? Math.min(_vm.perPage * _vm.currentPage, _vm.totalRows)
                        : 0
                    ) +
                    " of " +
                    _vm._s(_vm.totalRows > 0 ? _vm.totalRows : 0) +
                    " entries "
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "jobCardModal",
          attrs: {
            id: "jobCardDetailsModal",
            title: "Job Card Details",
            size: "xl",
            "hide-footer": "",
          },
        },
        [
          _c("b-table", {
            attrs: {
              striped: "",
              hover: "",
              responsive: "",
              items: _vm.modalJobCards,
              fields: _vm.modalFields,
            },
            scopedSlots: _vm._u([
              {
                key: "cell(name)",
                fn: function (data) {
                  return [
                    _c(
                      "b-tooltip",
                      { attrs: { title: "View details", placement: "top" } },
                      [
                        _c(
                          "a",
                          {
                            staticStyle: {
                              cursor: "pointer",
                              "text-decoration": "underline",
                              color: "blue",
                            },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.goToProductPage(data.item.id)
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(data.item.name) + " ")]
                        ),
                      ]
                    ),
                  ]
                },
              },
              {
                key: "cell(startDate)",
                fn: function (data) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.dayjs(data.item.startDate).format("DD/MM/YYYY")
                        ) +
                        " "
                    ),
                  ]
                },
              },
              {
                key: "cell(endDate)",
                fn: function (data) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.dayjs(data.item.endDate).format("DD/MM/YYYY")
                        ) +
                        " "
                    ),
                  ]
                },
              },
              {
                key: "cell(status)",
                fn: function (data) {
                  return [
                    data.item.status === 0
                      ? _c("b-badge", { attrs: { variant: "info" } }, [
                          _c("span", [_vm._v("Not Started")]),
                        ])
                      : data.item.status === 1
                      ? _c("b-badge", { attrs: { variant: "secondary" } }, [
                          _c("span", [_vm._v("Started")]),
                        ])
                      : data.item.status === 2
                      ? _c("b-badge", { attrs: { variant: "primary" } }, [
                          _c("span", [_vm._v("Completed")]),
                        ])
                      : data.item.status === 3
                      ? _c("b-badge", { attrs: { variant: "danger" } }, [
                          _c("span", [_vm._v("Cancelled")]),
                        ])
                      : data.item.status === 4
                      ? _c("b-badge", { attrs: { variant: "warning" } }, [
                          _c("span", [_vm._v("Blocked")]),
                        ])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }